import React, { useEffect, useState } from "react";
import Activity from "./Activity";
import axios from "axios";
import { changeActivities } from "../../endpoints";

interface Props {
  number: string;
  description: string;
  client: string;
  status: string;
  requester: string;
  coordinator: string;
  type: string;
}

interface data {
  number: string;
  description: string;
  status: string;
  category: string;
  timespend: string;
  currentplantime: string;
  remainingtime: string;
  operator: string;
  plannedfinaldate: string;
  plannedstartdate: string;
  startdate: string;
  processingStatus: string;
}

const Change = ({
  number,
  description,
  client,
  status,
  requester,
  coordinator,
  type,
}: Props) => {
  const [isActivitiesOpen, setIsActivitiesOpen] = useState(false);
  const [data, setData] = useState<data[]>([]);
  const apiKey = process.env.REACT_APP_API_KEY;
  const baseUrl = process.env.REACT_APP_BASE_URL;

  let changeContainer =
    "w-full text-black border-b-2 border-gray-300 p-2 flex items-center text-sm hover:bg-gray-50";
  if (type === "Niet standaard wijziging") {
    changeContainer =
      "w-full text-black border-b-2 border-gray-300 p-2 cursor-pointer flex items-center text-sm hover:bg-gray-50";
  }

  // Change standard or non standard
  let standard = "SW";
  if (type === "Niet standaard wijziging") {
    standard = "NSW";
  }

  // Activities styling
  let activityContainer = "hidden";
  if (isActivitiesOpen === true) {
    activityContainer =
      "w-full border-b-2 border-gray-300 flex flex-col items-center";
  }

  // Open or close activities
  const openActivities = () => {
    if (type === "Niet standaard wijziging") {
      setIsActivitiesOpen(!isActivitiesOpen);
    }
  };

  useEffect(() => {
    if (isActivitiesOpen === true) {
      const fetchData = () => {
        axios
          .get(baseUrl + changeActivities, {
            params: { changeNumber: number },
            headers: {
              Authorization: apiKey,
            },
          })
          .then((response) => {
            setData(response.data.results);
          })
          .catch((error) => {
            console.error("There was an error!", error.response);
          });
      };

      fetchData();

      const intervalId = setInterval(fetchData, 600000);

      return () => clearInterval(intervalId);
    }
  }, [number, apiKey, isActivitiesOpen, baseUrl]);

  return (
    <>
      {/* Change */}
      <div className={changeContainer} onClick={openActivities}>
        <p className="w-1/12 pr-[2%]">{number}</p>
        <p className="w-3/12">{description}</p>
        <p className="w-2/12 text-left">{client}</p>
        <p className="w-2/12 text-left">{status}</p>
        <p className="w-1/12 text-left">{standard}</p>
        <p className="w-2/12 text-left">{requester}</p>
        <p className="w-2/12 text-left">{coordinator}</p>
      </div>
      {/* Change activities */}
      <div className={activityContainer}>
        <div className="flex justify-center items-center text-black bg-gray-100 w-[70vw] h-[4vh] rounded-2xl mt-auto mb-auto text-[1vh]">
          <p className="w-[10vh] text-center mt-auto mb-auto">Number</p>
          <p className="w-[14vh] text-left mt-auto mb-auto">Description</p>
          <p className="w-[10vh] text-center mt-auto mb-auto">Status</p>
          <p className="w-[10vh] text-center mt-auto mb-auto">Category</p>
          <p className="w-[10vh] text-center mt-auto mb-auto">Time Spend</p>
          <p className="w-[10vh] text-center mt-auto mb-auto">
            Current Plan Time
          </p>
          <p className="w-[10vh] text-center mt-auto mb-auto">Remaining Time</p>
          <p className="w-[10vh] text-center mt-auto mb-auto">Operator</p>
          <p className="w-[10vh] text-center mt-auto mb-auto">
            Planned Final date
          </p>
          <p className="w-[10vh] text-center mt-auto mb-auto">
            Planned Start Date
          </p>
          <p className="w-[10vh] text-center mt-auto mb-auto">Start Date</p>
        </div>
        <div>
          {data.map((activity, index) => (
            <Activity
              key={index}
              number={activity.number}
              description={activity.description}
              status={activity.status}
              category={activity.category}
              timespend={activity.timespend}
              currentplantime={activity.currentplantime}
              remainingtime={activity.remainingtime}
              operator={activity.operator}
              plannedfinaldate={activity.plannedfinaldate}
              plannedstartdate={activity.plannedstartdate}
              startdate={activity.startdate}
              processingStatus={activity.processingStatus}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default Change;
